export default "__VITE_ASSET__D4qbHt$y__"